import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { useFomoCoupon } from "../../hooks/useFomoCoupon.js";
import { useFomoCouponTextPersistence } from "../../hooks/useFomoCouponTextPersistence.js";
import { __ } from "../../utils/i18n.js";
import { localStorageTest } from "../../utils/localStorageTest.js";
const LOCAL_STORAGE_NAME_FOMO_COUPON_IN_APP_REF = "real-commerce-coupon-in-app";
const LOCAL_STORAGE_NAME_FOMO_COUPON_USER_OF_PRODUCT = "real-commerce-user-of-product";
const disableFomoCoupon = (obj)=>{
    if (localStorageTest()) {
        if (obj.reason === "in-app") {
            localStorage.setItem(LOCAL_STORAGE_NAME_FOMO_COUPON_IN_APP_REF, "1");
        } else if (obj.reason === "user-of-product") {
            const productIds = (localStorage.getItem(LOCAL_STORAGE_NAME_FOMO_COUPON_USER_OF_PRODUCT) || "").split(",").filter(Boolean);
            const sId = `${obj.productId}`;
            if (productIds.indexOf(sId) === -1) {
                productIds.push(sId);
                localStorage.setItem(LOCAL_STORAGE_NAME_FOMO_COUPON_USER_OF_PRODUCT, productIds.join(","));
            }
        }
    }
};
const FomoCouponBanner = (param)=>{
    let { product, disclaimer } = param;
    const coupon = useFomoCoupon(product);
    const { interpolatedComponent, configuration } = useFomoCouponTextPersistence(coupon, {
        interpolateCouponInPercent: /*#__PURE__*/ _jsx("strong", {
            className: "fomo-coupon-percent"
        }),
        interpolateCouponString: /*#__PURE__*/ _jsx("span", {
            className: "fomo-coupon-string"
        })
    });
    const supportsLocalStorage = useMemo(()=>localStorageTest(), []);
    const inAppRef = useMemo(()=>window.location.search.indexOf("&promo=in-app") > -1 || supportsLocalStorage && !!localStorage.getItem(LOCAL_STORAGE_NAME_FOMO_COUPON_IN_APP_REF), []);
    const userOfProduct = useMemo(()=>supportsLocalStorage && `,${localStorage.getItem(LOCAL_STORAGE_NAME_FOMO_COUPON_USER_OF_PRODUCT) || ""},`.indexOf(`,${product},`) > -1, [
        product
    ]);
    const disabled = inAppRef || userOfProduct;
    useEffect(()=>{
        if (inAppRef) {
            disableFomoCoupon({
                reason: "in-app"
            });
        }
    }, [
        inAppRef
    ]);
    // Render disclaimer after a given element
    useEffect(()=>{
        const disclaimerElement = disclaimer ? document.querySelector(disclaimer) : undefined;
        if (!disabled && configuration && disclaimerElement) {
            const { coupon: couponString, valueInPercent, validUntil } = coupon;
            const element = document.createElement("p");
            element.className = "fomo-coupon-disclaimer";
            element.setAttribute("data-product", product);
            element.innerHTML = __("The coupon %s is valid until %s. Only for new customers who have not yet ordered this product. The discount of %d%% applies to the first invoicing period.", couponString, new Date(new Date(validUntil).getTime() + new Date().getTimezoneOffset() * 60 * 1000).toLocaleDateString(document.body.parentElement.getAttribute("lang")), valueInPercent);
            disclaimerElement.appendChild(element);
            return ()=>{
                element.remove();
            };
        } else {
            return ()=>{
            // Silence is golden.
            };
        }
    }, [
        disabled,
        configuration,
        coupon
    ]);
    return disabled ? null : /*#__PURE__*/ _jsx(_Fragment, {
        children: interpolatedComponent
    });
};
export { FomoCouponBanner, disableFomoCoupon };
